export default "__VITE_ASSET__C5Nz8Zoi__"